module.exports = __webpack_public_path__ + "img/8.2841cb64.jpeg";